import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './styles.css';

/* Global cross-section state for seat selection (Registry → Apply).
 * Kept as a window-level channel so any deeply nested component can publish
 * or subscribe without prop-drilling. Initialized once before the tree mounts.
 */
if (typeof window !== 'undefined' && !window.__02100) {
  window.__02100 = {
    selectedSeat: null,
    listeners: new Set(),
    setSeat(n) {
      this.selectedSeat = n;
      this.listeners.forEach((fn) => fn(n));
    },
  };
}

createRoot(document.getElementById('root')).render(<App />);
